// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/receipt-percent.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/receipt-percent'

import { Icon, type IconComponentProps } from '../icon'

export const ReceiptPercentIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
